<template>
<div class="container">
  <vx-card title="Catálogos">

    <vs-table stripe pagination search :max-items="30" :data="catalogs">
      <template slot="header">
        <vs-button @click="showNewCatalogDialog = true" class="float-right mb-2">
          Nuevo catálogo
        </vs-button>
      </template>
      <template slot="thead">
        <vs-th>Categoría</vs-th>
        <vs-th>Valores</vs-th>
        <vs-th>Opciones</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr v-for="catalog in data">
          <vs-td>{{ catalog.category }}</vs-td>
          <vs-td>{{ catalog.items}}</vs-td>
          <vs-td>
            <vs-button
                @click="$router.push('/risk-model/admin/catalog/' + catalog.id)"
                color="dark"
                size="small">
              Editar
            </vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>

  <vs-popup title="Nuevo catálogo" :active.sync="showNewCatalogDialog">
    <vs-input
        v-model="form.category"
        class="w-full"
        label="Nombre del catálogo"></vs-input>

    <vs-input
        v-model="form.description"
        class="w-full mt-2"
        label="Valor"></vs-input>

    <vs-input
        type="number"
        v-model="form.value"
        class="w-full mt-2"
        label="Puntaje"></vs-input>

    <vs-button @click="saveNewCatalogHandle" class="mt-4">
      Guardar
    </vs-button>
  </vs-popup>
</div>
</template>
<script>
export default {
  name: "RiskModelCatalogs",
  data: () => ({
    catalogs: [],
    form: {
      category: '',
      description: '',
      value: 0
    },
    showNewCatalogDialog: false
  }),
  mounted() {
    this.$vs.loading();
    axios.get("/api/risk-model/catalog").then(({data}) => {
      this.catalogs = data;
      this.$vs.loading.close();
    }).catch(() => {
      this.$vs.loading.close();
    })
  },
  methods: {
    async saveNewCatalogHandle() {
      this.$vs.loading();
      try {
        const {data} = await axios.post("/api/risk-model/catalog", this.form);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Catálogo creado",
          text: "El catálogo se ha creado correctamente",
          color: "success"
        });
        this.catalogs.push(data);
        this.showNewCatalogDialog = false;
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: "Ha ocurrido un error al crear el catálogo",
          color: "danger"
        });
      }
    }
  }
}
</script>
<style scoped>

</style>